/*
 * iOS 16-18 has a tight per-tab WebKit memory ceiling. Decoded image
 * bitmaps live above the JS heap and routinely tip pages into the
 * "A problem repeatedly occurred" content-process kill. Cap any
 * Shopify CDN URL above 1600px wide down to 1600. ~13MB decoded vs
 * ~30MB+ at 2400px and ~70MB at 3840px.
 *
 * Best-effort: by the time this runs (defer), the HTML preload
 * scanner may already have started fetches for some images. The
 * MutationObserver catches anything mounted later (section hydration,
 * lazy galleries, JS-injected media).
 */
(function () {
  var ua = navigator.userAgent || '';
  var likelyIOS = /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var m = /OS (\d+)[_\.]/.exec(ua);
  if (!likelyIOS || !m) return;
  var major = parseInt(m[1], 10);
  if (major < 16 || major > 18) return;

  var MAX = 1600;

  function capUrl(url) {
    if (!url) return url;
    return url.replace(/([?&])width=(\d+)/g, function (whole, prefix, w) {
      return parseInt(w, 10) > MAX ? prefix + 'width=' + MAX : whole;
    });
  }

  function capSrcset(srcset) {
    if (!srcset) return srcset;
    var out = [];
    srcset.split(',').forEach(function (entry) {
      var s = entry.trim();
      if (!s) return;
      var match = /^(.+?)\s+(\d+)w$/.exec(s);
      if (!match) { out.push(s); return; }
      var width = parseInt(match[2], 10);
      if (width > MAX) return;
      out.push(capUrl(match[1]) + ' ' + width + 'w');
    });
    return out.join(', ');
  }

  function processImg(img) {
    if (img.dataset.iosCapped) return;
    img.dataset.iosCapped = '1';
    var src = img.getAttribute('src');
    if (src) img.setAttribute('src', capUrl(src));
    var srcset = img.getAttribute('srcset');
    if (srcset) img.setAttribute('srcset', capSrcset(srcset));
  }

  function processLink(link) {
    if (link.dataset.iosCapped) return;
    if (link.rel !== 'preload' || link.as !== 'image') return;
    link.dataset.iosCapped = '1';
    var href = link.getAttribute('href');
    if (href) link.setAttribute('href', capUrl(href));
    var iss = link.getAttribute('imagesrcset');
    if (iss) link.setAttribute('imagesrcset', capSrcset(iss));
  }

  function processRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('img').forEach(processImg);
    root.querySelectorAll('link[rel="preload"][as="image"]').forEach(processLink);
  }

  processRoot(document);

  var observer = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'IMG') processImg(node);
        else if (node.tagName === 'LINK') processLink(node);
        else processRoot(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
